export const permissionMapping = {
  91: { subject: 'Tms', action: 'view' },
  111: { subject: 'TmsContainer', action: 'edit' },
  133: { subject: 'TmsTag', action: 'view' },
  122: { subject: 'TmsTag', action: 'create' },
  145: { subject: 'TmsTag', action: 'edit' },
  181: { subject: 'TmsDeploy', action: 'view' },
  171: { subject: 'TmsTest', action: 'view' },
  161: { subject: 'TmsGenerate', action: 'view' },
  153: { subject: 'TmsRule', action: 'view' },

  3001: { subject: 'TrustCategories', action: 'view' },
  3004: { subject: 'TrustOptions', action: 'edit' },

  4001: { subject: 'TmsBranch', action: 'create' },

  6010: { subject: 'LibraryManagement', action: 'view' },

  30003: { subject: 'DmsStream', action: 'view' },
  30004: { subject: 'DmsStream', action: 'create' },
  30005: { subject: 'DmsStream', action: 'edit' },

  /* Fuse */
  70: { subject: 'Fuse', action: 'all' },
  70001: { subject: 'Fuse', action: 'activate' },
  70002: { subject: 'Fuse', action: 'statistic' },

  2003801: { subject: 'Option', action: 'update' },

  /* Cookie Scanner rights */
  300001: { subject: 'CookieScanner', action: 'view' },
  300002: { subject: 'CookieScanner', action: 'edit' },
  300003: { subject: 'CookieScanner', action: 'generate' },
  300004: { subject: 'CookieScanner', action: 'deploy' },
  300005: { subject: 'CookieScannerSettings', action: 'edit' },
  300006: { subject: 'CookieScannerLocalisation', action: 'edit' },

  80001: { subject: 'DestinationTemplateBuilder', action: 'view' },
  80002: { subject: 'DestinationTemplateBuilder', action: 'create' },
  80003: { subject: 'DestinationTemplateBuilder', action: 'publish' },

  6666: { subject: 'CreditUsage', action: 'view' },

  30025: { subject: 'DataGovernanceEnrichment', action: 'view' },
  30026: { subject: 'DataGovernanceEnrichment', action: 'create' },
  30027: { subject: 'DataGovernanceStorageSettings', action: 'create' },
  30028: { subject: 'DataGovernanceStorageSettings', action: 'view' },

  1001: { subject: 'Destinations', action: 'view' },
  1002: { subject: 'Destinations', action: 'create' },
  1003: { subject: 'Destinations', action: 'edit' },
};
